import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/KER_APP_OKRChecker-8.png'
import _imports_1 from '../assets/okr_checker_heading.png'
import _imports_2 from '../assets/Wortmarke_Schwarz@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-5687e7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row align-items-stretch vh-100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 text-center d-none d-md-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "OKR Logo",
    class: "img-fluid"
  })
], -1))
const _hoisted_4 = { class: "col-md-6 d-flex align-items-center justify-content-center" }
const _hoisted_5 = { class: "width-form" }
const _hoisted_6 = { class: "c d-flex flex-column justify-content-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "OKR Logo",
    class: "mb-3 heading-img"
  })
], -1))
const _hoisted_8 = { class: "card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "Login")
], -1))
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "anmelden",
  class: "btn btn-primary"
}, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_16 = { class: "mt-3 text-center" }
const _hoisted_17 = { class: "text-center mt-4 mb-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://keravonos.de" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Logo",
    width: "120"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_RouterLink, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("form", {
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"])),
                    class: "form-group"
                  }, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "email",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      class: "form-control",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ]),
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      class: "form-control",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ]),
                    _hoisted_13,
                    _hoisted_14
                  ], 32),
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_16, [
                    _createTextVNode(" Noch kein Konto? "),
                    _createVNode(_component_RouterLink, { to: "/register" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hier registrieren")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_17, [
      _createElementVNode("p", null, [
        _createTextVNode(" Made with "),
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'heart'],
          class: "heart"
        }),
        _createTextVNode(" by "),
        _hoisted_18
      ])
    ])
  ], 64))
}